import React from 'react';
import Users  from 'pages/Users';

export const InstallerList = ({
  item,
  ...props
}) => {
  return (
  <Users.List
    url={'installer-users'}
    match={{url: `installer-user`}}
  />
  )
}

export default InstallerList;



// WEBPACK FOOTER //
// ./src/pages/Users/InstallerList.jsx